<!-- 登录页 -->
<template>
  <div class="login-box uni-login">
    <div class="login-container login-cont">
      <div class="img-box">
        <img class="logo-img" src="@/assets/images/logo.png" alt="">
        <img class="login-cont-img" src="@/assets/images/login-cont-img.png" alt="">
      </div>
      <div class="cont-r">
        <div v-if="isShowPort == 1" class="btn-box">
          <button class="btn" @click="choicePortClick('adult')">
            <img class="btn-icon" src="@/assets/images/choice_port1.png" alt="">
            <span class="text">成人高等教育入口</span>
            <img class="btn-arrow" src="@/assets/images/login-arrow.png" alt="">
          </button>
          <button class="btn" @click="choicePortClick('own')">
            <img class="btn-icon" src="@/assets/images/choice_port2.png" alt="">
            <span class="text">自学考试入口</span>
            <img class="btn-arrow" src="@/assets/images/login-arrow.png" alt="">
          </button>
          <!-- <button class="btn" @click="choicePortClick('graduationProve')">
            <img class="btn-icon" src="@/assets/images/choice_port3.png" alt="">
            <span class="text">毕业证明书</span>
            <img class="btn-arrow" src="@/assets/images/login-arrow.png" alt="">
          </button> -->
        </div>
        <!--login  -->
        <div class="login-content" v-else-if="isShowPort == 2">
          <div class="title-box">
            <div class="login-content_icon" @click="backClick"><i class="el-icon-arrow-left"></i></div>
            <div class="login-content_title">
              {{portValue | portValueFilter}}
            </div>
          </div>
            <!-- 电脑登陆 -->
            <el-tabs v-model="activeName" class="uni-tabs" v-show="!isActive">
              <!-- 密码登陆1   -->
              <el-tab-pane label="密码登陆" name="first">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                  <!-- 身份证 -->
                  <div class="uni-input-group">
                    <span
                      class="uni-label"
                      :class="{
                        active:
                          isLabelActive == 'account' || ruleForm.account != '',
                      }"
                      @click="inputGroupClick"
                      >手机号/学号</span
                    >

                    <el-form-item prop="account" class="uni-input">
                      <el-input
                        clearable
                        v-model.trim="ruleForm.account"
                        name="account"
                        type="text"
                        autocomplete="new-password"
                        @focus="changeLabelFocus"
                        @blur="changeLabelBlur"
                      ></el-input>
                    </el-form-item>
                  </div>

                  <!-- 密码 -->
                  <div class="uni-input-group">
                    <span
                      class="uni-label"
                      :class="{
                        active:
                          isLabelActive == 'password' || ruleForm.password != '',
                      }"
                      @click="inputGroupClick"
                      >密码</span
                    >

                    <el-form-item prop="password" class="uni-input">
                      <!-- @keyup.enter.native="refer('密码')" -->
                      <el-input
                        autocomplete="new-password"
                        v-model="ruleForm.password"
                        name="password"
                        :type="isOpen"
                        @focus="changeLabelFocus"
                        @blur="changeLabelBlur"
                      ></el-input>
                    </el-form-item>

                    <i
                      class="iconfont iconclose_eyes_"
                      @click="showPassword"
                      v-show="isOpen == 'password'"
                    ></i>
                    <i
                      class="iconfont iconyanjing"
                      @click="showPassword"
                      v-show="isOpen == 'text'"
                    ></i>
                  </div>
                  <!-- 验证码 -->
                  <div class="uni-input-group">
                    <span
                      class="uni-label"
                      :class="{
                        active:
                          isLabelActive == 'verify_code' || ruleForm.verify_code != '',
                      }"
                      @click="inputGroupClick"
                      >验证码</span
                    >

                    <el-form-item prop="verify_code" class="uni-input">
                      <div style="display: flex;">
                        <el-input
                          clearable
                          v-model.trim="ruleForm.verify_code"
                          name="verify_code"
                          type="text"
                          @focus="changeLabelFocus"
                          @blur="changeLabelBlur"
                          @keyup.enter.native="refer('密码')"
                          style="width: 60%;"
                        ></el-input>
                        <img class="img" :src="verifyCodeData.verifyCodeImg" @click="getCodeData" alt="" style="width: 40%;cursor: pointer;">
                      </div>
                    </el-form-item>
                  </div>
                  <el-link
                    type="info"
                    style="float: right; color: #5879ff"
                    @click="handleForgetPwd"
                    >忘记密码
                  </el-link>
                  <el-button type="primary" class="refer-btn" @click="refer('密码')"
                    >登陆
                  </el-button>
                </el-form>
              </el-tab-pane>

              <!-- 验证码登陆 -->
              <el-tab-pane label="验证码登陆" name="second">
                <el-form :model="codeForm" :rules="codeRules" ref="codeForm">
                  <!-- 手机号 -->
                  <div class="uni-input-group">
                    <span
                      class="uni-label"
                      :class="{
                        active: isLabelActive == 'mobile' || codeForm.mobile != '',
                      }"
                      @click="inputGroupClick"
                      >手机号</span
                    >

                    <el-form-item prop="mobile" class="uni-input">
                      <el-input
                        clearable
                        autocomplete="off"
                        v-model.trim="codeForm.mobile"
                        name="mobile"
                        @focus="changeLabelFocus"
                        @blur="changeLabelBlur"
                      ></el-input>
                    </el-form-item>
                  </div>

                  <!-- 验证码 -->
                  <div class="uni-input-group">
                    <span
                      class="uni-label"
                      :class="{
                        active: isLabelActive == 'code' || codeForm.code != '',
                      }"
                      @click="inputGroupClick"
                      >验证码</span
                    >

                    <el-form-item prop="code" class="uni-input">
                      <el-input
                        autocomplete="off"
                        v-model="codeForm.code"
                        name="code"
                        @focus="changeLabelFocus"
                        @blur="changeLabelBlur"
                        @keyup.enter.native="refer('验证码')"
                      ></el-input>
                    </el-form-item>

                    <el-button
                      round
                      class="uni-code"
                      @click="getCode(60)"
                      :disabled="isTimer"
                      >{{ !isTimer ? "获取验证码" : `(${timerCount}s) 重发` }}
                    </el-button>
                  </div>

                  <el-button
                    type="primary"
                    class="refer-btn"
                    @click="refer('验证码')"
                    >登陆
                  </el-button>
                </el-form>
              </el-tab-pane>
            </el-tabs>
            <!-- 微信登陆 -->
            <!--<div class="uni-wx-content" v-show="isActive">
              <div id="login_container">
                <img :src="qrCode" width="350" />
              </div>
            </div>-->
            <!-- <div class="uni-tips" v-if="!isActive">
              登陆不成功?
              <span class="link" @click="concatFunc">联系管理员</span>
            </div> -->
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { mobileReg } from "@/utils/regExp";
import { login, v1MobileLogin, getCode, codeServe, pracLogin, getVerifyCode } from "@/api/login";
import { setStore, setLocalStore, getLocalStore } from "@/utils/localStorage";
import {selectMajor} from "@/api/basic";
import {mapMutations} from "vuex";
import JSEncrypt from '@/utils/RSA.js';

export default {
  name: "Login",
  filters: {
    // 端口列表
    portValueFilter(v){
      let obj = {
        'adult': '成人高等教育入口',
        'own': '自学考试入口',
        // 'practicalAssessment': '实践考核及毕业设计入口',
      };
      return obj[v];
    },
  },
  data() {
    return {
      isShowPort: 1,  //选择入口 1 继续教育/自考考试 2登录 3选择班级
      portValue: "",  //选择入口的值

      activeName: "first",
      isActive: false,
      isLabelActive: "",
      timerCount: 60,
      timer: null,
      isTimer: false,
      isOpen: "password",
      qrCode: "",
      ticket: "",
      //验证码图片 数据
      verifyCodeData: {
        verifyCodeImg: '',  
        verify_token: '',
      },
      ruleForm: {
        account: "",
        password: "",
        verify_code: '',
        verify_token: '',
      },
      codeForm: {
        mobile: "",
        code: "",
      },
      rules: {
        account: [
          {
            required: true,
            message: "请输入手机号/学号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
        verify_code: [{required: true, message: "请输入验证码", trigger: "blur",}],
      },
      codeRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: mobileReg,
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
      codeData: "",
      codeText: "",
      ipData: "",

      classCurrent:'',
      classList:[],

      // 实践考核数据
      practicalAssessmentRuleForm: {
        identity: '',  //身份证号
        exam_number: '',  //准考证号
        student_title: '',  //学生姓名
        phone: '',  //手机号
        sms_code: '',  //验证码
      },
      practicalAssessmentRules: {
        identity: [{required: true, message: "请输入身份证号", trigger: "blur"}],
        exam_number: [{required: true, message: "请输入准考证号", trigger: "blur"}],
        student_title: [{required: true, message: "请输入学生姓名", trigger: "blur"}],
        phone: [{required: true, message: "请输入手机号", trigger: "blur"}],
        sms_code: [{required: true, message: "请输入验证码", trigger: "blur"}],
      },
    };
  },
  created() {
    document.body.className = "";
    document.title = "重庆医科大学";
    this.clearCache();
    const entranceType = localStorage.getItem('_ENTRANCETYPE')
    // if(entranceType){
    //   this.isShowPort = false
    // }
    // else{
    //   this.isShowPort = true
    // }
  },
  mounted() {

    //this.getQrcode();
    const searchName = window.location.search;
    if (searchName !== "") {
      const token = getLocalStore("token");
      const [, urlData] = searchName.split("?");
      const [urlDataArr, urlDataArr1] = urlData.split("&");
      const [, urlDataCode] = urlDataArr.split("=");
      const [, urlDataCode1] = urlDataArr1.split("=");
      if (urlDataCode1 !== "None" && token) {
        this.codeBind(urlDataCode, urlDataCode1, token);
        return;
      }
      if (urlDataCode1 === "None") {
        this.getUserIP((ip) => {
          this.ipData = ip || "ffzs";
          setStore("ipData", this.ipData);
        });
      }
    } else {
      this.getUserIP((ip) => {
        this.ipData = ip || "ffzs";
        setStore("ipData", this.ipData);
      });
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  methods: {
    ...mapMutations("common", ["gerStudentMajorMutation"]),

    // 获取验证码图片
    getCodeData(){
      getVerifyCode().then(res => {
            const { img, verify_token } = res.result;
            this.verifyCodeData.verifyCodeImg = img;
            this.verifyCodeData.verify_token = verify_token;
            this.ruleForm.verify_token = verify_token;
        });
    },

    // 返回
    backClick(){
      this.isShowPort = 1;
      this.ruleForm.account = '';
      this.ruleForm.password = '';
      this.ruleForm.verify_code = '';
      this.ruleForm.verify_token = '';
      this.verifyCodeData.verifyCodeImg = '';
      this.verifyCodeData.verify_token = '';
    },

    // 学位申报登录
    // degreeApplicationSignIn(){
    //   let userInfo = {
    //     user_type: 'student',
    //   };
    //   setStore("userInfo", userInfo); //用户信息
    //   this.$router.push({
    //     name: "degreeApplication",
    //   });
    // },

    // 选择入口
    choicePortClick(v){
      this.portValue = v;
      // window.localStorage.setItem('_ENTRANCETYPE',v)
      this.$store.dispatch('permission/SETENTRANCETYPE', v);
      if(v === 'adult' || v === 'own'){
        this.isShowPort = 2;
        this.getCodeData();
      }
      else if(v === 'academicDegree'){
        // this.isShowPort = 4;
          this.$router.push({
            name: "degreeApplication",
          });
      }
      else if(v === 'graduationProve'){
        this.$router.push({
          name: "graduationProve",
        });
      }else if(v === 'practicalAssessment'){
        this.isShowPort = 5;
      }
    },
    async isLogin() {
      if (this.ticket) {
        const data = await codeServe.isLogin({ ticket: this.ticket });
        //console.log(data)
        if (data.code === 200) {
          if (data.result) {
            setStore("token", data.result.token); //token
            setLocalStore("token", data.result.token); //token
            setStore("userInfo", data.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(data.result));
            clearInterval(this.timer);
            // this.$message.success("登陆成功");
            if (data.result.user_type === "teacher") {
              // 根据老师的类型跳转页面
              this.$router.replace({
                path: this.IdentityFilter(

                  data.result.teacher_type_array[0]
                ),
              });
            } else if (data.result.user_type === "student") {
              // await this.selectZy(data.result.classList[0].profession_id);
              this.classList = data.result.classList
              this.isShowPort = 3;

              // await this.selectZy(data.result.classList[0].class_id);
              // if (data.result.first_login_verify === 0) {
              //   // this.$router.push("/upDataIDQr");
              //   this.$router.push("/verify");
              //   return;
              // }
              // this.$router.replace({
              //   path: "/Template",
              // });
            }
          }
        }
      }
    },
    getUserIP(onNewIP) {
      //  onNewIp - your listener function for new IPs
      let MyPeerConnection =
        window.RTCPeerConnection ||
        window.mozRTCPeerConnection ||
        window.webkitRTCPeerConnection;
      let pc = new MyPeerConnection({
        iceServers: [],
      });
      let noop = () => {};
      let localIPs = {};
      let ipRegex =
        /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g;
      let iterateIP = (ip) => {
        if (!localIPs[ip]) {
          onNewIP(ip);
        }
        localIPs[ip] = true;
      };
      pc.createDataChannel("");
      pc.createOffer()
        .then((sdp) => {
          sdp.sdp.split("\n").forEach(function (line) {
            if (line.indexOf("candidate") < 0) {
              return;
            }
            line.match(ipRegex).forEach(iterateIP);
          });
          pc.setLocalDescription(sdp, noop, noop);
        })
        .catch((reason) => {
          console.log(reason);
        });
      pc.onicecandidate = (ice) => {
        if (
          !ice ||
          !ice.candidate ||
          !ice.candidate.candidate ||
          !ice.candidate.candidate.match(ipRegex)
        ) {
          return;
        }
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP);
      };
    },
    clearCache() {
      this.$store.commit("common/clearStore");
      window.sessionStorage.clear();
    },
    isUrl(type) {
      let urlText = "";
      if (type === 1) urlText = "https://www.zpjykj.com/";
      if (type === 2) urlText = "https://beian.miit.gov.cn/#/Integrated/index";
      if (type === 3)
        urlText =
          "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010602502220";
      window.open(urlText);
    },
    async codeBind(code, url, token) {
      const codeDataLogin = await codeServe.login(
        {
          code: code,
        },
        {
          token: token,
        }
      );
      if (codeDataLogin.data.message === "绑定成功") {
        this.$message({
          message: "绑定成功",
          type: "success",
        });
      }
    },
    //  忘记密码跳转
    handleForgetPwd() {
      this.$router.push("/forgetPwd");
    },
    // 获取微信二维码图片
    async getQrcode() {
      const data = await codeServe.qrcode({ scene_str: "courier_login" });
      if (data.code === 200) {
        this.qrCode = data.result.qrcode;
        this.ticket = data.result.ticket;
      }
    },
    // 改变登陆方式
    changeLogin() {
      this.isActive = !this.isActive;
      if (this.isActive) {
        this.timer = setInterval(this.isLogin, 3000);
      } else {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    // label动画
    inputGroupClick(event) {
      const target = event.currentTarget;
      target.nextElementSibling.firstElementChild.firstElementChild.firstElementChild.focus();
    },
    changeLabelFocus(event) {
      const { name } = event.currentTarget;
      this.isLabelActive = name;
    },
    changeLabelBlur() {
      this.isLabelActive = "";
    },
    // 验证码 实践考核
    getCodePracticalAssessment(timeCount) {
      this.$refs.practicalAssessmentRuleForm.validateField("phone", (errorMessage) => {
        if (errorMessage === "") {
          this.getVerificationCodePracticalAssessment();
          if (!this.timer) {
            this.timerCount = timeCount;
            this.isTimer = true;
            this.timer = setInterval(() => {
              if (this.timerCount > 0 && this.timerCount <= timeCount) {
                this.timerCount -= 1;
              } else {
                this.isTimer = false;
                clearInterval(this.timer); // 清除定时器
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    //验证码请求
    async getVerificationCodePracticalAssessment() {
      const params = {
        mobile: this.practicalAssessmentRuleForm.phone,
      };
      getCode(params).then((res) => {
        if (res.code === 200) {
          this.$message({ message: "发送成功", type: "success" });
        } else {
          this.$message.error("新增失败,请重试!");
        }
      });
    },
    // 验证码
    getCode(timeCount) {
      this.$refs.codeForm.validateField("mobile", (errorMessage) => {
        if (errorMessage === "") {
          this.getVerificationCode().then(res => {
              if (!this.timer) {
                this.timerCount = timeCount;
                this.isTimer = true;
                this.timer = setInterval(() => {
                  if (this.timerCount > 0 && this.timerCount <= timeCount) {
                    this.timerCount -= 1;
                  } else {
                    this.isTimer = false;
                    clearInterval(this.timer); // 清除定时器
                    this.timer = null;
                  }
                }, 1000);
              }
          });
        }
      });
    },
    //验证码请求
    getVerificationCode() {
      return new Promise((resolve, reject) => { 
        const params = {
          mobile: this.codeForm.mobile,
        };
        getCode(params).then((res) => {
          if (res.code === 200) {
            this.$message({ message: "发送成功", type: "success" });
            resolve(res);
          } else {
            this.$message.error("新增失败,请重试!");
          }
        });
      });
    },
    // 显示隐藏密码
    showPassword() {
      this.isOpen = this.isOpen === "password" ? "text" : "password";
    },
    // 联系管理员
    // concatFunc() {
    //   this.$confirm("023-62652911,023-62652917", "联系管理员", {
    //     customClass: "uni-message-box",
    //     confirmButtonText: "返回登陆",
    //     showCancelButton: false,
    //     center: true,
    //   });
    // },
    // 登陆
    async refer(code) {
      let params;
      if (code === "验证码") {
        params = this.codeForm
        v1MobileLogin(params).then((res) => {
          if (res.code === 200) {
            setStore("token", res.result.token); //token
            setLocalStore("token", res.result.token); //token
            setStore("userInfo", res.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));
            // this.$message.success("登陆成功");
            if (res.result.user_type === "teacher") {
              this.$store.commit("common/changeTeacherMutation", '2');
              // 根据老师的类型跳转页面
              this.$router.replace({
                path: this.IdentityFilter(
                  // res.result.teacher_type_array[0]
                  '2'
                ),
              });
            } else if (res.result.user_type === "student") {
              this.classList = res.result.classList
              if(this.classList.length > 1){
                this.isShowPort = 3;
                return
              }
              this.classCurrent = this.classList[0].class_id
              this.classConfirm(res);
              // this.selectZy(res.result.classList[0].profession_id);
              // this.selectZy(res.result.classList[0].class_id);
              // if (res.result.first_login_verify === 0) {
              //   // this.$router.push("/upDataIDQr");
              //   this.$router.push("/verify");
              //   return;
              // }
              // this.$router.replace({
              //   path: "/Template",
              // });
            }
          }
        });
      } else if(code === '密码') {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            params = {
              account: this.ruleForm.account,
              password: JSEncrypt.RSAEncrypt(this.ruleForm.password),
              verify_token: this.ruleForm.verify_token,
              verify_code: this.ruleForm.verify_code,
            };
            login(params).then((res) => {
              if (res.code === 200) {
                setStore("token", res.result.token); //token
                // setLocalStore("token", res.result.token); //token
                setStore("userInfo", res.result); //用户信息
                this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));

                // this.$message.success("登陆成功");
                if (res.result.user_type === "teacher") {
                  // console.log(res.result.teacher_type_array);
                  this.$store.commit("common/changeTeacherMutation", '2');
                  this.$router.replace({
                    // path: this.IdentityFilter(res.result.teacher_type_array[0]),
                    path: this.IdentityFilter('2'),
                  });
                } else if (res.result.user_type === "student") {
                  if(this.portValue === 'adult'){
                    this.$store.dispatch('permission/enterConfirmActions', res.result.class_info.enter_confirm);
                    this.$store.dispatch('permission/enterSchoolImgCheckActions', res.result.enter_school_img_check);
                    if(res.result.enter_school_img){
                      this.$store.dispatch('permission/enterSchoolImgActions', res.result.enter_school_img);
                    }
                    if(res.result.sign_img){
                      this.$store.dispatch('permission/signImgActions', res.result.sign_img);
                    }
                    if(res.result.is_registration){
                      this.$store.dispatch('permission/isRegistrationActions', res.result.is_registration);
                    }
                  }
                  this.$store.dispatch('permission/firstLoginVerifyActions', res.result.first_login_verify);
                  this.classList = res.result.classList
                  if(this.classList.length > 1){
                    this.isShowPort = 3;
                    return
                  }
                  this.classCurrent = this.classList[0].class_id;
                  this.classConfirm(res);
                  // // this.selectZy(res.result.classList[0].profession_id);
                  // if (res.result.first_login_verify === 0) {
                  //   // this.$router.push("/upDataIDQr");
                  //   this.$router.push("/verify");
                  //   return;
                  // }
                  // // if (res.result.is_notification == 0) {
                  // //   this.$router.push("/notice");
                  // //   return;
                  // // }
                  // this.$router.replace({
                  //   path: "/Template",
                  // });
                }
              }
            }).catch(() => {
              this.getCodeData();
            });
          }
        });
        
      }else if(code === 'practicalAssessment'){
        // 实践考核入口
        params = this.practicalAssessmentRuleForm;
        pracLogin(params).then(res => {
          if(res.code == 200){
            setStore("token", res.result.token); //token
            // setLocalStore("token", res.result.token); //token
            setStore("userInfo", res.result); //用户信息
            this.$store.dispatch('permission/userInfoActions', JSON.stringify(res.result));

            this.$router.push({
              name: "practicalAssessment",
            });
          }
        });
      }
    },

    async classConfirm(loginRes){
      if(this.$base.isNull(this.classCurrent)){
        this.$message.warning("请选择班级");
        return
      }
      let id = this.classCurrent

      let res = await selectMajor({class_id: id});
      if(res.code != 200){
        this.$message.error(res.msg);
        return
      }else{
        if(this.$store.state.permission._ENTRANCETYPE === 'adult'){
          const {pre_review_status} = res.result;
          if(pre_review_status == 0){
              this.$router.push({
                path: "/preEducationAlone",
                query: {
                  classId: id,
                },
              });
            return;
          }
        }
      }

      let arr = this.classList.filter(item => item.class_id == id)
      let data = arr[0]
      this.gerStudentMajorMutation(data);
      // 确认信息
      if(this.portValue === 'adult'){
        let classInfo = loginRes.result.class_info;
        if(classInfo.enter_confirm == 0){
          this.$router.push({
            path: "/confirmInfo",
          });
          return;
        }
      }
      if(data.first_login_verify == 0){
        this.$router.push({
          path: "/verify",
          query: {
            classId: id,
          },
        });
        return;
      }
      if(this.portValue === 'adult'){
        if(loginRes.result.enter_school_img_check != 2){
          this.$router.push({
            path: "/uploadAdmissionPhotos",
          });
          return;
        }
        if(loginRes.result.is_registration == 0){
          this.$router.push({
            path: "/infoRegForm",
          });
          return;
        }
      }
      // this.$router.replace({
      //   name: "home",
      // });
      this.$router.push({
        name: "home",
      });
    },

    async selectZy(val) {
      await selectMajor({
        class_id: val,
      });
    },
    //  老师身份过滤
    IdentityFilter(value) {
      // console.log(value);
      if (value == "3") {
        //  阅卷老师
        return "/markingData";
      } else if (value == "1") {
        //  班主任
        return "/headTeacher";
      } else if (value == "2") {
        // 上课老师
        return "/attendClassTeacher";
      } else {
        //  暂时还没有阅卷督察
        return "/headTeacher";
      }
    },
  },
};
</script>
<style lang="scss">
 .login-box{
    .uni-tabs {
      // padding: 0 70px;
      margin-top: 80px;
      .el-tabs__nav-scroll {
        display: flex;
        justify-content: center;
      }

      .el-tabs__nav-wrap::after {
        background: none;
      }

      .el-tabs__item {
        font-size: 18px;
      }
    }
    .el-input__inner {
      border: none;
      border-bottom: 1px solid $gray;
      border-radius: 0;
      padding-left: 0;
      padding-right: 0;
    }
 }

</style>
<style lang="scss" scoped>
  .login-box{
    width: 100vw;
    height: 100vh;
    background-image: url("~@/assets/images/login_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-cont{
      width: 1236px;
      height: 607px;
      background-image: url("~@/assets/images/login-cont-bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      padding: 53px 181px 0 141px;
      display: flex;
      justify-content: space-between;
      .img-box{
        width: 506px;
        .logo-img{
          width: 297px;
          object-fit: contain;
        }
        .login-cont-img{
          margin-top: 99px;
          width: 506px;
          height: 264px;
          object-fit: contain;
        }
      }
      .cont-r{
        width: calc(100% - 506px - 67px);
        .btn-box{
          padding-top: calc(186px - 53px);
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          .btn{
            width: 289px;
            height: 61px;
            background: linear-gradient(86deg, #0B69F7, #387EDB, #6AB8FC);
            border-radius: 31px;
            border: none;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 28px;
            & ~ .btn{
              margin-top: 37px;
            }
            .btn-icon{
              width: 82px;
              height: 57px;
              object-fit: contain;
              margin-left: -29px;
            }
            .text{
              font-size: 20px;
              font-weight: bold;
              color: #fff;
            }
            .btn-arrow{
              width: 25px;
              height: 14px;
              object-fit: contain;
            }
          }
        }
        .login-content {
          width: 100%;
          height: 100%;
          background: $white;
          float: right;
          position: relative;
          .title-box{
            width: 100%;
            position: absolute;
            top: -20px;
            display: flex;
            align-items: center;
            .login-content_icon{
              font-size: 24px;
              cursor: pointer;
              z-index: 9;
            }
            .login-content_title{
              width: calc(100% - 24px - 20px);
              text-align: center;
              font-size: 18px;
            }
          }
          .uni-input-group {
            position: relative;
            margin-top: 30px;

            .uni-label {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              color: #999;
              transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
              font-size: 16px;
              transform-origin: left top;
              z-index: $zindexTooltip;

              &.active {
                transform: translateY(-120%) scale(0.8);
              }
            }

            .iconfont {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              cursor: pointer;
              font-size: 22px;
            }
          }
        }
        .refer-btn {
          width: 100%;
          height: 56px;
          border-radius: 28px;
          margin-top: 25px;
          font-size: 16px;
          background: linear-gradient(86deg, #0B69F7, #387EDB, #6AB8FC);
          border: none;
        }
        .uni-code {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 104px;
          height: 36px;
          font-size: 12px;
          z-index: $zindexTooltip;
          padding: 0;
        }
      }
    }
  }
</style>
